export const getIsAdmin = () => !IS_PRODUCTION
